import { Controller } from "@hotwired/stimulus";
import {
  appendRspoSuggestion,
  renderSelectedRspo,
} from "../components/rspo-directory-dom";

export default class extends Controller {
  static targets = ["input", "rspoNumber", "suggestions", "selected"];

  disconnect() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    this.abortController?.abort();
  }

  search() {
    const query = this.inputTarget.value.trim();
    this.clearSelection();
    if (this.debounceTimer) clearTimeout(this.debounceTimer);

    this.debounceTimer = setTimeout(() => {
      if (!query) {
        this.renderSuggestions([]);
        return;
      }
      this.loadSuggestions(query);
    }, 200);
  }

  dismiss(event) {
    if (!this.suggestionsTarget.contains(event.target) && event.target !== this.inputTarget) {
      this.suggestionsTarget.classList.add("hidden");
    }
  }

  async loadSuggestions(query) {
    this.abortController?.abort();
    this.abortController = new AbortController();

    try {
      const response = await fetch(`/api/rspo/search?q=${encodeURIComponent(query)}`, {
        headers: { Accept: "application/json" },
        signal: this.abortController.signal,
      });
      if (!response.ok) throw new Error("RSPO search failed");
      const items = await response.json();
      if (this.inputTarget.value.trim() !== query) return;
      this.renderSuggestions(Array.isArray(items) ? items : []);
    } catch (error) {
      if (error.name !== "AbortError") this.renderSuggestions([]);
    }
  }

  clearSelection() {
    this.rspoNumberTarget.value = "";
    this.selectedTarget.replaceChildren();
  }

  renderSuggestions(items) {
    this.suggestionsTarget.replaceChildren();
    if (!items.length) {
      this.suggestionsTarget.classList.add("hidden");
      return;
    }

    items.forEach((item) => {
      appendRspoSuggestion(document, this.suggestionsTarget, item, (selected) => this.selectItem(selected));
    });
    this.suggestionsTarget.classList.remove("hidden");
  }

  selectItem(item) {
    this.rspoNumberTarget.value = item.rspo_number == null ? "" : String(item.rspo_number);
    renderSelectedRspo(document, this.selectedTarget, item);
    this.suggestionsTarget.classList.add("hidden");
  }
}
